import React from "react";
// react component that copies the given text inside your clipboard
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  Button
} from "reactstrap";
import Select from "react-select";
import {
  Link
} from "react-router-dom";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { toast } from 'react-toastify';
import ConnectorService from '../../services/api/Connector'
// import CircleLoader from "react-spinners/CircleLoader";
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Switch from "react-bootstrap-switch";
import { Scrollbars } from 'react-custom-scrollbars';
import axios from "axios";

import Element from 'components/Element.js';
import { FormContext } from '../Connectors/FormContext';
import { uuidv4 } from '../../components/Notebook/operations/notebook';
import { CONNECTOR_BASE_URL } from "settings/shared/constants";

const styles = {
  errorBox: {
    textAlign: "center",
    marginBottom: 20
  },
  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    backgroundColor: "rgb(249, 228, 228)",
    padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
  passwordHint: {
    color: "#000",
    fontSize: 12
  }
}
class NewConnection extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      errorSubmitted: false,
      connectiontimeout: 0,
      enableWriteAccess: true,
      enableConnector: true,
      name: "",
      password: "",
      role: "",
      server: "",
      connectiontype: "",
      connectiontype_change: "",
      user: "",
      warehouse: "",
      btnActions: "Create Connection",
      editId: "",
      description: "",     
      connectorDTOS: [],
      groupvalue: [],
      swidth: window.innerWidth,
      sheight: window.innerHeight,
      connectorIcon: '',
      connectorTypeList: [],
      connectorVersionList: [],
      version: ""
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    let mode = this.props.location.state.mode;
    if (mode === "editConnector") {
      localStorage.removeItem("selectConnectorType");
      this.GetEditconnector(this.props.location.state.editId);
    }
    else if (mode === "fromChooseConnector") {
      this.setState({
        btnActions: "Create Connection",
        connectiontype: localStorage.getItem("selectConnectorType")
      });

    } else {
      localStorage.removeItem("selectConnectorType");
      this.setState({
        btnActions: "Create Connection",
      });
    }
  }

  getVersionList = () => {
    var versionList = []
    axios.get(CONNECTOR_BASE_URL + "master.json")
      .then(res => {
        if(res.status === 200) {
          this.setState({
            connectorTypeList: res.data
          })
          if(this.state.connectorIcon != "") {
            let connectorType = this.state.connectorIcon.split(".")
            if(connectorType.length > 0) {
              let connCategory = connectorType[0]
              let conntypes = connectorType[1]
              res.data.map((item, index) => {
                if (item.category === connCategory) {
                  item.conn_types.map((type, i) => {      
                    if (type.connector === conntypes) {
                      type.versions.map((version, index) => {
                        versionList.push(
                          {
                            label: version.version,
                            value: version.version,
                          })
                      })
                    }
                  })
                }
              })
            }
           
          }
          
        } else {
          this.setErrorMessage("Network Error")
        }       
      })

    this.setState({
      connectorVersionList: versionList
    })
  }

  getVersionNames = (versionPath) => {

  }



  handleSwitch(elem, state) {
    this.setState({ enableWriteAccess: state })
  }

  handleSwitchEnableConnector(elem, state) {
    this.setState({ enableConnector: state })
  }
  /* To get Static Input Text */
  handlefixedChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  /* To get Dynamic Input Text */
  handleChange = (id, event) => {
    this.state.groupvalue.forEach((field, index) => {
      const { name, type } = field;
      if (id === name) {
        switch (type) {
          case 'checkbox':
            field['fieldValue'] = event.target.checked;
            break;

          default:
            field['fieldValue'] = event.target.value;
            break;
        }
        this.setState({
          groupvalue: [
            ...this.state.groupvalue.slice(0, index),
            Object.assign({}, this.state.groupvalue[index], field),
            ...this.state.groupvalue.slice(index + 1)
          ]
        });
      }
    });
  }

  handlechangeTimeout = e => {
    this.setState({ connectiontimeout: e.target.value });

  };

  cancelClick = () => {
    this.props.history.push('/integration/connectors/');
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ swidth: window.innerWidth, sheight: window.innerHeight });
  }

  setErrorMessage(message) {
    if (message === "") {
      this.setState({
        errorMessage: message,
        errorSubmitted: false
      })
    } else {
      document.getElementById('errorDiv').scrollIntoView()
      this.setState({
        errorMessage: message,
        errorSubmitted: true
      });
    }
  }
  // Edit Connecotors
  GetEditconnector(id) {
    this.setState({
      loading: true,
      btnActions: "Update",
      editId: id,
    });
    ConnectorService.getConnectorById(id)
      .then((response) => {
        if (response.status === 'SUCCESS') {
          this.setState({
            name: response.connectorsDTO.name,
            description: response.connectorsDTO.description,
            loading: false,
            connectorIcon: response.connectorsDTO.connectorType,
            enableConnector: response.connectorsDTO.enable
          }, () => {
            this.getVersionList();
          })
          var groupfields = []
          response.connectorsDTO.connectorConfig.map((item, index) => {
          
          groupfields.push({
                  name: item.name,
                  type: item.type,
                  required: item.required,
                  secret: item.secret,
                  fieldValue: item.fieldValue, 
                  placeholder: this.createPlaceholder(item.name)
                })
        })

        this.setState({
          groupvalue : [...groupfields]
        })


          
        } else {
          this.setState({ loading: false });
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      }).catch((error) => {
        this.setState({ loading: false });
      })
  }


  createPlaceholder = (str) => {
    let text = str.match(/[A-Z | a-z][a-z]+|[0-9]+/g).join(" ");  
    return text.toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  DeleteConnectorConfirm = () => {
    confirmAlert({
      title: 'Remove Connector',
      message: 'Are you sure to remove this connector -' + this.state.name + '?',
      buttons: [
        {
          label: 'Yes',
          onClick: e => this.DeleteConnector()
        },
        {
          label: 'No',
          onClick: () => console.log('')
        }
      ]
    });
  }
  // Delete Connector
  DeleteConnector = () => {
    if (this.state.editId !== "") {
      ConnectorService.removeConnector(this.state.editId).then((response) => {
        if (response.status === 'SUCCESS') {
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Connector Deleted Successfully!</b></i>);
          this.props.history.push('/integration/connectors/');
        } else {
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
        }
      });
    }
  }
  // Submit Edit Connection Data
  handleSubmit = (event) => {
    event.preventDefault();
    let post = {
      description: this.state.description,
      enable: this.state.enableConnector,
      connectorConfig: this.state.groupvalue,
      name: this.state.name,
      version: this.state.version
    }
    this.PostConnector(post)
  }

  // Put Edited Connectors

  PostConnector = (post) => {
    this.setErrorMessage("");
    if (!this.state.errorSubmitted) {
      if (this.state.editId != "") {
        ConnectorService.UpdateConnector(post, this.state.editId)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Connector Updated Successfully!</b></i>);
              this.props.history.push('/integration/connectors/');
            } else {
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
            }
          }
          );
      } else {
        ConnectorService.PostConnector(post)
          .then((response) => {
            if (response.status === 'SUCCESS') {
              toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Connector Created Successfully!</b></i>);
              this.props.history.push('/integration/connectors/'); 
            } else {
              toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
            }
          }
          );
      }
    } else {
      console.error('Invalid Form')
    }
  }

  BrowseConnector = () => {
    this.props.history.push('/connectors/ChooseConnector');
  }

  getConnnectorIcon = (icon_path) => {
   if(icon_path != "") {
    return CONNECTOR_BASE_URL + icon_path.replace(".", "/") + "/icon.png"
   }    
  }

  handleVersion = (event) => {
    this.setState({
      version : event.value
    })
  }



  render() {
    let ConnDescription;
    if (!this.state.description) {
      ConnDescription = ""
    } else {
      ConnDescription = this.state.description
    }
    return (

      <>
        <PanelHeader
          content={
            <div className="header text-center">

            </div>
          }
        />
        <div className="content">
          <LoadingOverlay
            active={this.state.loading}
            spinner={<ScaleLoader
              height={35}
              width={5}
              radius={2}
              margin={2}
              color={"#123abc"}
              loading={this.state.loading}
            />}
          >
            <Row>
              <div className=" col" id="errorDiv">
                <Col xs={12} md={12}>
                  <Card >
                    <CardHeader>
                      <Row className="align-items-center">
                        <div className="col">
                          {this.state.editId !== "" && <h5 className="mb-0">Update {this.state.connectiontype} Connector</h5>}
                          {this.state.editId === "" && <h5 className="mb-0">Create {this.state.connectiontype} Connector</h5>}
                        </div>
                        <div className="col text-right">
                          <Link to="/integration/connectors/" >
                            <span className="close clear-filter">×</span>
                          </Link>
                        </div>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <div className="carcontent">
                        <Scrollbars autoHeight autoHeightMin={this.state.sheight - 120}>

                          {this.state.errorSubmitted &&
                            <div style={styles.errorBox}>
                              <span style={styles.error}>{this.state.errorMessage}</span>
                            </div>
                          }
                          <div style={{ backgroundColor: '#eee' }}>
                            <code><b>Connection Details</b></code>
                          </div>
                          <Card className="card-contributions hoverproject">
                            <CardBody>
                              <div className="carcontent">
                                <Row className="mt-12">
                                  <Col className="mb-12 mb-xl-0" xl="12">
                                    <FormContext.Provider value={{
                                      state: this.state,
                                      handleSubmit: this.handleSubmit,
                                      handleChange: this.handleChange,
                                    }}
                                    >
                                      {this.state.errorSubmitted &&
                                        <div style={styles.errorBox}>
                                          <span style={styles.error}>{this.state.errorMessage}</span>
                                        </div>
                                      }
                                      <Row className="mt-12" style={{ paddingRight: 10 }}>
                                        <Col className="mb-12 mb-xl-0" xl="12">
                                          <Row className="icon-examples" style={{ marginTop: 10 }}>
                                            <Col lg="4">
                                              <Label md="5">Name *</Label>
                                              <FormGroup>
                                                <Input
                                                  className="form-control"
                                                  placeholder="Name"
                                                  name="name"
                                                  value={this.state.name}
                                                  type="text"
                                                  onChange={this.handlefixedChange} />
                                              </FormGroup>
                                            </Col>
                                            <Col lg="4">
                                              <Label md="5">Description *</Label>
                                              <FormGroup>
                                                <Input
                                                  className="form-control descrip"
                                                  placeholder="Description"
                                                  name="description"
                                                  value={ConnDescription}
                                                  type="text"
                                                  onChange={this.handlefixedChange} noValidate />
                                              </FormGroup>
                                            </Col>
                                            <Col lg="4">
                                              <Label md="12">Version</Label>
                                              <FormGroup>
                                                <Select className="selectMargin"
                                                  values={this.state.connectorVersionList.filter(item => item.value === this.state.version)}
                                                  options={this.state.connectorVersionList}
                                                  onChange={this.handleVersion}
                                                />
                                              </FormGroup>
                                            </Col>
                                            {this.state.connectorVersionList}
                                          </Row>
                                        </Col>
                                      </Row>
                                      <br></br>
                                      <Row xs="12">
                                        <Col lg="4">
                                          <Label lg="5">Type *</Label>
                                          {this.state.editId === "" && <img src={this.getConnnectorIcon(this.state.connectorIcon)} alt={this.state.connectortype} className="typeimg" />}
                                          {this.state.editId !== "" && <img src={this.getConnnectorIcon(this.state.connectorIcon)} alt={this.state.connectortype} className="typeimg" />}
                                        </Col>

                                      </Row>
                                      <br></br>
                                      {this.state.editId !== "" && <Row>
                                        <Col md="6">
                                          <FormGroup style={{ marginLeft: 14 }}>
                                            <Label>Enable Connector </Label>&nbsp; &nbsp;&nbsp; &nbsp;<Switch onChange={(el, state) => this.handleSwitchEnableConnector(el, state)} value={this.state.enableConnector} name='enbale connector' data-on-color="secondary" data-off-color="default" />
                                          </FormGroup>
                                        </Col>

                                      </Row>}
                                      <Row className="icon-examples">
                                        {this.state.groupvalue.map((item, index) => {
                                          return (
                                            <Col md={4} id={uuidv4()} >
                                              <Element key={index} field={item} />
                                            </Col>
                                          )
                                        })}
                                      </Row>
                                      <Row className="stickybuttons">
                                        <Col lg="1">
                                          <FormGroup>
                                            <Button
                                              color="secondary"
                                              size="sm"
                                              type="submit"
                                              onClick={this.cancelClick}
                                            >
                                              Cancel
                                            </Button>
                                          </FormGroup>
                                        </Col>
                                        {this.state.editId !== "" && <Col lg="1">
                                          <FormGroup>
                                            <Button
                                              color="danger"
                                              size="sm"
                                              type="submit"
                                              onClick={e => {
                                                e.preventDefault()
                                                this.DeleteConnectorConfirm()
                                              }}>
                                              Delete
                                            </Button>
                                          </FormGroup>
                                        </Col>}
                                        <Col lg="2">
                                          <FormGroup>
                                            <Button
                                              color="primary"
                                              size="sm"
                                              type="submit"
                                              disabled = {this.state.btnActions === "Update"}
                                              onClick={(e) => this.handleSubmit(e)}
                                            >
                                              {this.state.btnActions}
                                            </Button>
                                          </FormGroup>
                                        </Col>
                                      </Row>
                                    </FormContext.Provider>
                                  </Col>
                                </Row>
                              </div>
                            </CardBody>
                          </Card>
                          <hr className="my-4" />

                        </Scrollbars>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </div>
            </Row>
          </LoadingOverlay>

        </div>
      </>
    );
  }
}

export default NewConnection;

